import {DateObject} from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

export function formatGregorianDateToJalali(value) {
    if (!value) {
        return value;
    }

    try {
        return new DateObject({date: value, format: 'YYYY-MM-DD'})
            .convert(persian, persian_fa)
            .format('YYYY/MM/DD');
    } catch {
        return value;
    }
}

export function parseGregorianDateFilter(value) {
    if (!value) {
        return null;
    }

    try {
        return new DateObject({date: value, format: 'YYYY-MM-DD'});
    } catch {
        return null;
    }
}
